import React, { createContext, useContext } from 'react';
import { updateDocumentTitle } from '../utils/documentTitle';

// Create a context for backward compatibility
const DomainContext = createContext();

export const DomainProvider = ({ children }) => {
  // Function to update document title for backward compatibility
  const updateDocumentTitleCompat = (title) => {
    updateDocumentTitle(title);
  };

  // Set fixed values for the domain
  const domainValues = {
    isFinCog: false,
    isCellCog: true,
    hostname: window.location.hostname,
    updateDocumentTitle: updateDocumentTitleCompat
  };

  return (
    <DomainContext.Provider value={domainValues}>
      {children}
    </DomainContext.Provider>
  );
};

// Export the hook for backward compatibility
export const useDomain = () => useContext(DomainContext);
